import React from 'react'
import { Link } from 'react-router-dom'

const PageNotFound = () => {
  return (
    <div className="bg-brand_nero flex flex-col justify-center items-center h-[800px] py-24 my-auto text-white  w-full">
        <div className="bg-brand_jaguar h-[400px] px-24 flex flex-col justify-center text-center items-center w-[600px]">
        <img src='https://cdn-icons-png.flaticon.com/512/4923/4923785.png' width={'60px'} alt="" />
          <h1 className="text-2xl my-3 ">Oops !!! Someting went wrong.</h1>
          <h1>The Link you have clicked may be broken or the page have been removed</h1>
          <h1 className='my-8'>Visit the <Link  to='/' className='text-brand_yellow'>Home page</Link> or <Link to='/contact' className='text-brand_yellow'>Contact us</Link> about the Problem</h1>
          
          
          
        </div>
      </div>
  )
}

export default PageNotFound